import { render, staticRenderFns } from "./CompanyRegister.vue?vue&type=template&id=b55d4ece&scoped=true"
import script from "./CompanyRegister.vue?vue&type=script&lang=js"
export * from "./CompanyRegister.vue?vue&type=script&lang=js"
import style0 from "./CompanyRegister.vue?vue&type=style&index=0&id=b55d4ece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55d4ece",
  null
  
)

export default component.exports